// src/App.tsx
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import ScrollToTop from "./components/ScrollToTop"; // Imported ScrollToTop
import Home from "./pages/Home";
import AboutUs from "./pages/AboutUs";
import CarService from "./pages/CarService";
import TurboRebuild from "./pages/TurboRebuild";
import Contact from "./pages/Contact";
import NotFound from "./pages/NotFound";
import GDPR from "./pages/GDPR";
import Cookies from "./pages/Cookies";
import Terms from "./pages/Terms";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <ScrollToTop /> {/* Added ScrollToTop here */}
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/o-nas" element={<AboutUs />} />
            <Route path="/avtoservis" element={<CarService />} />
            <Route path="/obnova-turbo" element={<TurboRebuild />} />
            <Route path="/kontakt" element={<Contact />} />
            <Route path="/gdpr" element={<GDPR />} />
            <Route path="/cookies" element={<Cookies />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;